/* tslint:disable */
/* eslint-disable */
/**
 * My REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: jason.tai@octopus-tech.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReaderLogDto
 */
export interface ReaderLogDto {
    /**
     * 
     * @type {string}
     * @memberof ReaderLogDto
     */
    content?: string;
}

export function ReaderLogDtoFromJSON(json: any): ReaderLogDto {
    return ReaderLogDtoFromJSONTyped(json, false);
}

export function ReaderLogDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReaderLogDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'content': !exists(json, 'content') ? undefined : json['content'],
    };
}

export function ReaderLogDtoToJSON(value?: ReaderLogDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'content': value.content,
    };
}

